import { ConfigureStoreOptions, Middleware, Tuple, UnknownAction } from "@reduxjs/toolkit";
import { Middlewares } from "@reduxjs/toolkit/dist/configureStore";

export function makeMiddleware<S, T extends Middleware = Middleware>(
  middleware: T[]
): ConfigureStoreOptions<S, UnknownAction, Tuple<Middlewares<S>>>["middleware"] {
  return getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActionPaths: ["meta.arg"],
      },
    }).concat(middleware);
  };
}
